/** Default axios timeout — avoids hung requests when a proxied service is unreachable. */
export const API_REQUEST_TIMEOUT_MS = 20_000
